import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    transform: translateX(-100%) skewX(-12deg);
    opacity: 0;
  }
  12% {
    opacity: 1;
  }
  100% {
    transform: translateX(220%) skewX(-12deg);
    opacity: 0;
  }
`;

export const Wrapper = styled.div`
  margin: ${(props) => props.margin || 'auto'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.fullWidth ? '99%' : '81%')};
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  padding: clamp(1.1rem, 3.5vw, 2rem);
  border: 1px solid rgba(21, 43, 78, 0.1);
  background: linear-gradient(
    155deg,
    #ffffff 0%,
    #f3f7fd 38%,
    #e8f0fb 72%,
    #f6f9ff 100%
  );
  box-shadow:
    0 10px 40px rgba(21, 43, 78, 0.09),
    0 1px 0 rgba(255, 255, 255, 0.95) inset;

  &::after {
    content: '';
    position: absolute;
    top: -10%;
    left: 0;
    width: 55%;
    height: 120%;
    background: linear-gradient(
      95deg,
      transparent 0%,
      rgba(255, 255, 255, 0.65) 45%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: ${shimmer} 2.6s ease-in-out infinite;
    pointer-events: none;
  }

  & > * {
    position: relative;
    z-index: 1;
  }

  ${(props) => {
    switch (props.size) {
      case 'extra-small':
        return `
        height: auto;
        min-height: 4.5rem;
        max-height: none;
        overflow: visible;
        padding: 0.65rem 1rem;
        `;
      case 'small':
        return `
        height: 16vh;
        min-height: 16vh;
        `;
      case 'medium':
        return `
        height: 40vh;
        min-height: 40vh;
        `;
      case 'large':
        return `
        height: 50vh;
        min-height: 50vh;
        `;
      case 'extra-large':
        return `
        height: 100vh;
        min-height: 100vh;
        `;
      default:
        return `
        height: 40vh;
        min-height: 40vh;
        `;
    }
  }}

  @media (max-width: 800px) {
    width: 100%;
    border-radius: 16px;
    padding: 1rem 0.9rem;

    ${(props) => {
      switch (props.size) {
        case 'small':
          return `
          height: 24vh;
          min-height: 24vh;
          `;
        case 'medium':
          return `
          height: 30vh;
          min-height: 30vh;
          `;
        case 'large':
          return `
          height: 34vh;
          min-height: 34vh;
          `;
        default:
          return '';
      }
    }}
  }
`;

export const ContainerIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.1rem;
  text-align: center;
  position: relative;
  z-index: 2;
`;

export const LoadingIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;

  & > svg {
    margin: 0 !important;
    filter: drop-shadow(0 2px 8px rgba(21, 43, 78, 0.12));
  }
`;

export const TitleLoading = styled.span`
  font-size: clamp(1.05rem, 2.4vw, 1.45rem);
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #152b4e;
  line-height: 1.25;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);

  @media (max-width: 800px) {
    font-size: 1.05rem;
    letter-spacing: 0.1em;
  }
`;

export const TextLoading = styled.p`
  width: min(90%, 28rem);
  padding: 0.75rem 1rem 0;
  margin: 0 auto;
  font-size: 0.9rem;
  line-height: 1.55;
  text-align: center;
  color: #5c6b80;
  font-weight: 500;

  &.loading-text--emphasis {
    color: #3d4a5c;
    font-weight: 600;
  }

  @media (max-width: 800px) {
    width: 94%;
    font-size: 0.86rem;
    line-height: 1.45;
    padding-top: 0.65rem;
  }
`;
